export const getPageStartNumber = ({ recordsPerPage, pageNumber }) =>
  recordsPerPage * (pageNumber - 1) + 1;
